import { useState } from 'react';
import {
  ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import AnalyticsCard from './AnalyticsCard';

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-background-secondary border border-border-primary rounded-lg shadow-lg p-3 text-xs">
      <p className="font-semibold text-text-primary mb-1.5">{label}</p>
      {payload.map((p) => (
        <p key={p.name} className="flex items-center gap-2" style={{ color: p.color }}>
          <span className="w-2 h-2 rounded-full inline-block" style={{ background: p.color }} />
          {p.name}: <span className="font-semibold ml-auto pl-3">{p.value?.toLocaleString()}</span>
        </p>
      ))}
    </div>
  );
}

export default function ClaimsTrend({ data }) {
  const [view, setView] = useState('monthly');

  const display =
    view === 'monthly'
      ? data
      : (() => {
          const qtrs = {};
          data.forEach((d) => {
            const [y, m] = d.month.split('-');
            const q = `${y} Q${Math.ceil(parseInt(m) / 3)}`;
            if (!qtrs[q]) qtrs[q] = { month: q, completed: 0, failed: 0, total: 0 };
            qtrs[q].completed += d.completed;
            qtrs[q].failed += d.failed;
            qtrs[q].total += d.total;
          });
          return Object.values(qtrs);
        })();

  return (
    <AnalyticsCard title="Claims Volume Over Time">
      <div className="flex items-center gap-2 mb-4">
        {['monthly', 'quarterly'].map((v) => (
          <button
            key={v}
            onClick={() => setView(v)}
            className={`text-xs px-3 py-1 rounded-full font-medium transition-colors ${
              view === v
                ? 'bg-primary text-white'
                : 'bg-background-primary text-text-secondary hover:bg-background-hover'
            }`}
          >
            {v.charAt(0).toUpperCase() + v.slice(1)}
          </button>
        ))}
      </div>
      <ResponsiveContainer width="100%" height={260}>
        <ComposedChart data={display} margin={{ top: 4, right: 8, left: -10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey="month" tick={{ fontSize: 10, fill: '#7e848c' }} interval={view === 'monthly' ? 3 : 0} />
          <YAxis tick={{ fontSize: 10, fill: '#7e848c' }} />
          <Tooltip content={<ChartTooltip />} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          <Bar dataKey="completed" name="Completed" fill="#10b981" radius={[2, 2, 0, 0]} stackId="a" />
          <Bar dataKey="failed"    name="Failed"    fill="#ef4444" radius={[2, 2, 0, 0]} stackId="a" />
          <Line dataKey="total" name="Total" stroke="#0066cc" strokeWidth={2} dot={false} />
        </ComposedChart>
      </ResponsiveContainer>
    </AnalyticsCard>
  );
}
